const allowLogger = process.env.REACT_APP_ALLOW_LOGGER === 'true'

export const logger = {
  error: (error: any) =>
    allowLogger
      ? console.log({
          level: 'error',
          error
        })
      : undefined,
  info: (message: any) =>
    allowLogger
      ? console.log({
          level: 'info',
          message
        })
      : undefined
}
